const MRInfo = {
  'promiseTime': {
    title: 'Promise Time',
    description: 'PROMISE TIME is an automated text that alerts customers when their vehicle is expected to be ready. Updating Promise Time in Message Runner or the point of sale automatically sends the updated time to the customer.',
  },
  'callStore': {
    title: 'Call Store',
    description: 'CALL STORE sends an automated text to the customer asking them to call the store back in cases of the identification of additional recommended service not on the original work order.',
  },
  'beBack': {
    title: 'BeBack',
    description: 'BEBACK is an automated text that alerts customers that tire center crews are ready to service their vehicle and that the customer should return to the store for service.',
  },
  'vehicleReady': {
    title: 'Vehicle Ready',
    description: 'VEHICLE READY is an automated text that alerts customers that their vehicle service has been completed and is ready for them to return to the tire center to pick it up.',
  },
  'courtesyRides': {
    title: 'Cost Effective Courtesy Rides',
    description: 'Courtesy Rides is a complimentary service that stores can use to minimize the number of customers waiting at the store while saving operational costs and improving store productivity.',
    subtitles: ['The cost of using Store vehicle', 'The cost of coordinating a Lyft'],
    featureList: [
      [
        'Average cost of using a store vehicle is $10 PLUS store productivity',
        'Requires an average of 24 minutes of crew member time',
        'Store needs to be on-call for a return ride for the customer'
      ],
      [
        'Average cost of a Lyft is $15',
        'Return ride link is automatically sent to the customer'
      ]
    ], 
    footers: ['RESULT: Up to one hour of crew member time plus gas/wear and tear on store vehicle.', 'RESULT: No crew member time is needed']
  }
}

export default MRInfo;